/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface Reaction
 */
export interface Reaction {
    /**
     * Unique identifier for the reaction
     * @type {string}
     * @memberof Reaction
     */
    readonly id: string;
    /**
     * Type of entity this reaction is for
     * @type {string}
     * @memberof Reaction
     */
    reactableType: ReactionReactableTypeEnum;
    /**
     * ID of the entity this reaction is for
     * @type {string}
     * @memberof Reaction
     */
    reactableId: string;
    /**
     * Type of reaction (like or dislike)
     * @type {string}
     * @memberof Reaction
     */
    reactionType: ReactionReactionTypeEnum;
    /**
     * Timestamp when the reaction was created
     * @type {Date}
     * @memberof Reaction
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the reaction was last updated
     * @type {Date}
     * @memberof Reaction
     */
    readonly updatedAt: Date;
    /**
     * Account that created this reaction
     * @type {Account}
     * @memberof Reaction
     */
    readonly account: Account;
    /**
     * ID of the account that created this reaction
     * @type {string}
     * @memberof Reaction
     */
    readonly accountId: string;
}


/**
 * @export
 */
export const ReactionReactableTypeEnum = {
    Itinerary: 'itinerary',
    Post: 'post',
    Stop: 'stop'
} as const;
export type ReactionReactableTypeEnum = typeof ReactionReactableTypeEnum[keyof typeof ReactionReactableTypeEnum];

/**
 * @export
 */
export const ReactionReactionTypeEnum = {
    Like: 'like',
    Dislike: 'dislike'
} as const;
export type ReactionReactionTypeEnum = typeof ReactionReactionTypeEnum[keyof typeof ReactionReactionTypeEnum];


/**
 * Check if a given object implements the Reaction interface.
 */
export function instanceOfReaction(value: object): value is Reaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reactableType' in value) || value['reactableType'] === undefined) return false;
    if (!('reactableId' in value) || value['reactableId'] === undefined) return false;
    if (!('reactionType' in value) || value['reactionType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function ReactionFromJSON(json: any): Reaction {
    return ReactionFromJSONTyped(json, false);
}

export function ReactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reactableType': json['reactableType'],
        'reactableId': json['reactableId'],
        'reactionType': json['reactionType'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'account': AccountFromJSON(json['account']),
        'accountId': json['accountId'],
    };
}

  export function ReactionToJSON(json: any): Reaction {
      return ReactionToJSONTyped(json, false);
  }

  export function ReactionToJSONTyped(value?: Omit<Reaction, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reactableType': value['reactableType'],
        'reactableId': value['reactableId'],
        'reactionType': value['reactionType'],
    };
}

